import React, { useState, useEffect, useRef } from "react";
import mapboxgl from "mapbox-gl";
import { ref, getDownloadURL } from "firebase/storage";
import { storage, db, auth } from "../utils/firebase"; // Firebase config and auth
import { doc, getDoc, updateDoc, setDoc, arrayUnion, arrayRemove, collection, getDocs } from "firebase/firestore";
import "./MarianoGomes.css";
import Navbar from '../components/navbar/Navbar';
import Footer from '../components/footer/Footer';
import TripInspiration from "../components/carousel/TripInspiration";
import Posting from "../components/posts/Posting";
import Tisa360 from "./360/Tisa360";


const BahayTisa = () => {
  const location = "Bahay ni Tisa";
  const [bridgeData, setBridgeData] = useState(null);  
  const [imageUrl, setImageUrl] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const category = "Ancestral Houses and the One Asia Heritage"; // The category for this place
  const [user, setUser] = useState(null); // Logged-in user
  const [favorites, setFavorites] = useState({});
  const [isFavorited, setIsFavorited] = useState(false);
  const [rating, setRating] = useState(0);
  const [showMapModal, setShowMapModal] = useState(false); // Map modal state
  const mapContainerRef = useRef(null); // Ref for the Map container
      const [selectedImage, setSelectedImage] = useState(null);
    
    
      const handleImageClick = (url) => {
        setSelectedImage(url);
      };
      
      const closeLightbox = () => {
        setSelectedImage(null);
      };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchFavorites(currentUser.uid);
      }
    });
    return unsubscribe;
  }, []);

  // Fetch user favorites from Firestore
  const fetchFavorites = async (userId) => {
    const userDocRef = doc(db, "Users", userId);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      const userFavorites = userDoc.data().favorites || {};
      setFavorites(userFavorites);
      setIsFavorited(userFavorites[category]?.includes(location));
    } else {
      // Initialize an empty favorites field if it doesn't exist
      await setDoc(userDocRef, { favorites: {} });
      setFavorites({});
    }
  };

  useEffect(() => {
    const fetchBridgeData = async () => {
      try {
        const bridgesRef = collection(db, "historical_houses");
        const bridgesSnapshot = await getDocs(bridgesRef);

        const data = bridgesSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Assuming you want to use the first document as Zapote Bridge
        const zapoteBridge = data.find((bridge) => bridge.title === "Bahay ni Tisa");
        setBridgeData(zapoteBridge);
      } catch (error) {
        console.error("Error fetching bridge data: ", error);
      }
    };

    fetchBridgeData();
  }, []);

  

  // Toggle favorite state
  const toggleFavorite = async (event) => {
    event.stopPropagation(); // Prevent other click actions
    if (!user) return; // Button is already invisible for non-logged-in users

    const userDocRef = doc(db, "Users", user.uid);
    const updatedFavorites = { ...favorites };
    const isCurrentlyFavorited = updatedFavorites[category]?.includes(location);

    if (isCurrentlyFavorited) {
      // Remove from favorites
      updatedFavorites[category] = updatedFavorites[category].filter((name) => name !== location);
      await updateDoc(userDocRef, { [`favorites.${category}`]: arrayRemove(location) });
    } else {
      // Add to favorites
      updatedFavorites[category] = [...(updatedFavorites[category] || []), location];
      await updateDoc(userDocRef, { [`favorites.${category}`]: arrayUnion(location) });
    }

    setFavorites(updatedFavorites);
    setIsFavorited(!isCurrentlyFavorited);
  };


  useEffect(() => {
    // Fetch the hero image URL from Firebase Storage
    const fetchImage = async () => {
      try {
        const imageRef = ref(storage, "places/5BcLUToRZUvH1t32uJBm9.jpg"); // Path to the image in Firebase Storage
        const url = await getDownloadURL(imageRef);
        setImageUrl(url);
      } catch (error) {
        console.error("Error fetching image: ", error);
      }
    };


    const fetchPhotos = async () => {
      try {
        const imageRefs = [
          ref(storage, "places/1BcLUToRZUvH1t32uJBm9.jpg"),
          ref(storage, "places/2BcLUToRZUvH1t32uJBm9.jpg"),
          ref(storage, "places/3BcLUToRZUvH1t32uJBm9.jpg"),
          ref(storage, "places/4BcLUToRZUvH1t32uJBm9.jpg"),
        ];

        const urls = await Promise.all(imageRefs.map((imageRef) => getDownloadURL(imageRef)));
        setImageUrls(urls);
      } catch (error) {
        console.error("Error fetching photos: ", error);
      }
    };

    fetchImage();
    fetchPhotos();
  }, []);

  useEffect(() => {
    // Fetch the rating data from the 'posts' collection in Firestore
    const fetchRating = async () => {
      try {
        const postsRef = collection(db, "posts");
        const postsSnapshot = await getDocs(postsRef);
        let totalRating = 0;
        let ratingCount = 0;

        postsSnapshot.forEach((doc) => {
          const post = doc.data();
          if (post.location === location && post.rating) {
            totalRating += post.rating;
            ratingCount += 1;
          }
        });

        // Calculate the average rating
        if (ratingCount > 0) {
          setRating((totalRating / ratingCount).toFixed(1)); // Set the average rating with 1 decimal place
        } else {
          setRating(0); // If no ratings, set it to 0
        }
      } catch (error) {
        console.error("Error fetching ratings: ", error);
      }
    };

    fetchRating();
  }, [location]);

  useEffect(() => {
    if (!mapContainerRef.current || !showMapModal) return;
  
    mapboxgl.accessToken = "pk.eyJ1IjoiZWR3aW54eHgxMjMiLCJhIjoiY20zdjdoanFzMDVrMTJxc2c0NmVjdXd6biJ9.Ete8ni9gbs1o6va_XxsX3g";
  
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [120.942829, 14.459584], // Default center (the destination)
      zoom: 15,
      zoomControl: false,
    });
  
    // Track user's location and update map in real-time
    const geoWatchId = navigator.geolocation.watchPosition(
      (position) => {
        const userCoords = [position.coords.longitude, position.coords.latitude];
        map.flyTo({ center: userCoords, essential: true }); // Fly to the updated user location
  
        // Redraw route whenever the user’s location changes
        drawRoute(userCoords, [120.942829, 14.459584], map);
      },
      (error) => console.error("Error getting user location: ", error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  
    // Ensure the map doesn't reinitialize every time, only on first load
    map.on('load', () => {
      // Set initial route when the map is loaded
      drawRoute([14.459584, 120.942829], [120.942829, 14.459584], map);
    });
  
    // Clean up on unmount
    return () => {
      map.remove();
      navigator.geolocation.clearWatch(geoWatchId); // Clean up geolocation watch
    };
  }, [showMapModal]);
  
  // Function to draw the route between user and destination
  const drawRoute = async (userCoords, destinationCoords, map) => {
    const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${userCoords[0]},${userCoords[1]};${destinationCoords[0]},${destinationCoords[1]}?geometries=geojson&access_token=${mapboxgl.accessToken}`;
  
    try {
      const response = await fetch(url);
      const data = await response.json();
  
      if (data.routes && data.routes.length > 0) {
        const route = data.routes[0].geometry;
  
        if (map.getSource("route")) {
          map.getSource("route").setData(route); // Update the existing route
        } else {
          map.addSource("route", {
            type: "geojson",
            data: route,
          });
  
          map.addLayer({
            id: "route",
            type: "line",
            source: "route",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#3b9bfa",
              "line-width": 5,
            },
          });
        }
      }
    } catch (error) {
      console.error("Error fetching route data: ", error);
    }
  };
  


  if (!bridgeData) {
    return <p>Loading...</p>; 
  }

  return (
    <div>
      <Navbar />

      {/* Hero Section */}
          <div className="tulayzapote-container">
            {imageUrl ? (
              <div
                className="tulayzapote-hero"
                style={{ backgroundImage: `url(${imageUrl})` }}
              >
             <button className="go-to-place-btn" onClick={() => setShowMapModal(true)}>
                <i className="bi bi-geo-alt-fill"></i>
              </button>
                <div className="rating-display">
                  <span className="rating-stars">
                    {Array.from({ length: 5 }, (_, index) => (
                      <i
                        key={index}
                        className={`bi ${index < Math.round(rating) ? "bi-star-fill" : "bi-star"}`}
                      ></i>
                    ))}
                  </span>
                  <span className="rating-number">({rating})</span>
                </div>

                <button
                  className={`favorite-btn ${isFavorited ? "favorited" : ""}`}
                  onClick={toggleFavorite}
                  style={{ display: user ? "inline-block" : "none" }}
                >
                  <i className={`bi ${isFavorited ? "bi-heart-fill" : "bi-heart"}`}></i>
                </button>

              <div className="tulayzapote-overlay">
              <h1 className="tulayzapote-title">{bridgeData.title}</h1>
              <p className="tulayzapote-location">
                <i className="bi bi-geo-alt-fill"></i> {bridgeData.barangay}
              </p>
            </div>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </div>
      

      {/* Content Section */}
      <div className="tulayzapote-content">
        {bridgeData ? (
          <div className="tulayzapote-description">
            <h2>Discover {bridgeData.title}</h2>
            <p>
              <strong>Description:</strong> {bridgeData.description}
            </p>
          </div>
        ) : (
          <p>Loading description...</p>
        )}

        {/* Google Map (Beside the Description) */}
        <div className="tulayzapote-map">
          <iframe
            title="Tulay ng Zapote Map"
            src="https://www.google.com/maps/embed?pb=!4v1732752857985!6m8!1m7!1sIpVHuiWK1_aQu6yLI3gdqw!2m2!1d14.45957426952942!2d120.9428169352248!3f352.9023004139187!4f0.13211602859190918!5f0.7820865974627469"
            width="100%"
            height="300"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
<Tisa360/>
      <div className="tulayzapote-photos">
          <h3>{bridgeData.title} Photos</h3>
          <div className="photo-gallery">
            {imageUrls.length > 0 ? (
              imageUrls.map((url, index) => (
                <img
                  key={index}
                  src={url}
                  alt={`Zapotebridge ${index + 1}`}
                  className="photo"
                  onClick={() => handleImageClick(url)}
                  style={{ cursor: 'pointer' }}
                />
              ))
            ) : (
              <p>Loading photos...</p>
            )}
          </div>
          {selectedImage && (
            <div className="lightbox" onClick={closeLightbox}>
              <div className="lightbox-content">
                <img src={selectedImage} alt="Enlarged view" />
              </div>
            </div>
          )}
        </div>
        
      {showMapModal && (
          <div className="map-modal">
            <div className="map-modal-content">
              <button className="close-btn" onClick={() => setShowMapModal(false)}>
                Close
              </button>
              <div ref={mapContainerRef} className="map-container" style={{ height: "400px" }} />
            </div>
          </div>
        )}
      <Posting location={location} />

      <TripInspiration/>
      <Footer />
    </div>
  );
};

export default BahayTisa;
